import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import * as styles from './styles';
import { SURCHARGE_ID } from '../../../common';

const SnipcartCounter = ({ cartState }) => {
  const surchargeItemPresent = cartState && cartState.cartState.items.items.some((e => e.id === SURCHARGE_ID));
  const cartQuantity = surchargeItemPresent ? Math.max(0, cartState?.quantity - 1) : cartState?.quantity;

  return (
    <div
      id="cartCounter"
      className={cn(styles.snipcartCounter, {
        [styles.isActive]: cartState?.hasItems,
      })}
    >
      {/* DOC: Reduce one from quantity, and one is the tariff product */}
      <span>{cartQuantity}</span> 
    </div>
  );
};

SnipcartCounter.propTypes = {
  cartState: PropTypes.shape({
    quantity: PropTypes.number.isRequired,
    hasItems: PropTypes.bool.isRequired,
  }).isRequired,
};

export default SnipcartCounter;
